import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Derivative feature parameters */
export interface DerivativeParams {
  /** Reference to parent function element */
  of: string;
  /** Order of the derivative (1 = first derivative, 2 = second, etc.) */
  order?: number;
}

// =============================================================================
// DEFAULTS
// =============================================================================

export const DERIVATIVE_DEFAULT_PARAMS: Omit<DerivativeParams, 'of'> = {
  order: 1,
};

/**
 * Default theme for derivative feature.
 * Amber dashed curve.
 */
export const DERIVATIVE_DEFAULTS: FeatureStyleNode = {
  curve: { color: 'amber', strokeWidth: 2, dash: 2 },
};
